import { Fragment, ReactElement, useCallback, useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import Menu from '../components/Menu/Menu'
import Stats from '../components/Stats'
import Searchbar from '../components/Searchbar'
import styles from './Main.module.scss'
import useTranslation from '../Hooks/useTranslation'
import { useIsHomeAvailable } from '../Hooks/useHome'
import usePrefStore from '../stores/prefs'

function Main() {
   // States mémo pour historique
   // States
   const [searchText, setSearchText] = useState('')
   const [searchBar, setSearchBar] = useState<ReactElement | null>(null)
   const [stats, setStats] = useState<ReactElement | null>(null)
   //
   const { trans } = useTranslation()

   const onSearchChange = useCallback((text) => {
      setSearchText(text);
   }, [])

   useEffect(() => {
      setSearchBar(<Searchbar onChange={onSearchChange} text={searchText} />)
   }, [onSearchChange, searchText])

   useEffect(() => {
      setStats(<Stats />)
   }, [])

   // Garde d'accès : Accueil réservé (admin / internal non-manager, hors grand-utilisateur
   // et single-customer). Les retail-only (N1/N2, client…) sont renvoyés au catalogue, même
   // par accès direct à l'URL '/'. On attend prefsLoaded pour ne pas rediriger pendant le
   // chargement des prefs (sinon un admin serait bounce au 1er rendu).
   const isHomeAvailable = useIsHomeAvailable()
   const prefsLoaded = usePrefStore((s) => s.prefsLoaded)
   if (prefsLoaded && !isHomeAvailable) return <Navigate to="/catalog" replace />

   return (
      <Fragment>
         <Menu page="Main" />
         <div className={styles.main}>
            {searchBar}
            <div className={styles.content}>
               <div className={styles.header}>
                  <h1>
                     {trans("?Bienvenue")}
                  </h1>
               </div>
               {stats}
            </div>
         </div>
      </Fragment>
   )
}

export default Main
